import ScholarshipLayout from '../components/ScholarshipLayout.vue'
import Info from '../components/organizations/Information.vue'
import Requirements from '../components/organizations/Requirements.vue'
import Home from '../components/Home.vue'
import FormLayout from '../components/submission/FormLayout.vue'
import Review from '../components/submission/Review.vue'
import Login from '../components/users/LoginLayout.vue'
import Profilelayout from '../components/users/profile/ProfileLayout.vue'
// import ProfileShow from '../components/users/profile/Profile.vue'
import ProfileEdit from '../components/users/profile/ProfileEdit.vue'
import Status from '../components/submission/Status.vue'
import NotFoundComponent from '../components/NotFoundComponent.vue'
import ForgotPassword from '../components/users/ForgotPassword.vue'
import ResetPassword from '../components/users/ResetPassword.vue'
import ConfirmAccount from '../components/users/ConfirmAccount.vue'
import ResendConfirmation from '../components/users/ResendConfirmation.vue'

export default [
   //   {path: "/", component: Name, props: true, Name: ""}
   {
     path: "*",
     redirect: "/notFound"
   },

   {
     path: "/notFound",
     component: NotFoundComponent,
     name: "notFound",
     meta: { title: "Tassyl - Page Not Found"}
   },
   {
     path:"/",
     component: Home,
     name: "home",
     meta: { title: "Tassyl - Scholarship Home Page"}
  },
  {
    path:"/login",
    component: Login,
    meta: { title: "Tassyl - Login Page"}
  },
  {
    path:"/forgot_password",
    component: ForgotPassword,
    meta: { title: "Tassyl - Reset Password Form"}
  },
  {
    path:"/reset_password",
    component: ResetPassword,
    meta: { title: "Tassyl - Set New Password"}
  },
  {
    path:"/confirm_account",
    component: ConfirmAccount,
    name: "confirmAccount",
    meta: { title: "Tassyl - Confirmation Email Sent"}
  },
  {
    path:"/resend_confirmation",
    component: ResendConfirmation,
    name: "resendConfirmation",
    meta: { title: "Tassyl - Resend Password Confirmation Link"}
  },
  {
    path:"/profile",
    component: Profilelayout,
    meta: { requiresAuth: true, title: "Tassyl - Profile Page" }
  },
  {
    path:"/profile/edit",
    component: ProfileEdit,
    meta: { requiresAuth: true, title: "Tassyl - Profile Edit Page" }
  },
  {
    path: "/:organization_name/:scholarship_name",
    component: ScholarshipLayout,
    children: [
      {
        path: "", component: Info, meta: {title: "dynamically-create"}
      },
      {
        path: "information", component: Info, name: "information", meta: {title: "dynamically-create"}
      },
      {
        path: "requirements", component: Requirements, name: "requirements", meta: {title: "dynamically-create"}
      },
      {
        path: "apply", component: FormLayout, name: "apply", meta: { requiresAuth: true, title: "dynamically-create" }
      },
      {
        path: "review", component: Review, name: "review", meta: { requiresAuth: true, title: "dynamically-create" }
      },
      {
        path: "status", component: Status, name: "status", meta: { requiresAuth: true, title: "dynamically-create" }
      }
    ]
  }
]
